import React from 'react';
import { SEO } from '../components/SEO';
export function DatenschutzPage() {
  return <>
      <SEO title="Privacy Policy | Justus Kraft" description="Privacy policy for Justus Kraft LLC. Information on data collection, processing and your rights under the GDPR." keywords="privacy policy, GDPR, data protection, Justus Kraft" ogType="website" data-id="element-251" data-mp="roz49ciudvj6" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-252" data-mp="d1497phd3f2x">
        <div className="max-w-4xl mx-auto" data-id="element-253" data-mp="cyi0vnmncvjn">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-254" data-mp="8yhl9zntaeb0">
            Privacy Policy
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-255" data-mp="40zby85vtx2h">
            <section className="mb-8" data-id="element-256" data-mp="3v6ha5ef20sgy">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-257" data-mp="3v7iuyalvgtbv">
                1. Privacy at a Glance
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-258" data-mp="1ybuuo3as6siz">
                General Information
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-259" data-mp="3i25go0923f15">
                The following notes provide a simple overview of what happens
                to your personal data when you visit this website. Personal
                data is any data that can be used to identify you personally.
                For detailed information on data protection, please refer to
                the privacy policy set out below this text.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-260" data-mp="4nsp4g1o6c6i">
                Data Collection on This Website
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-261" data-mp="3r2v8ytz3yna4">
                <strong className="text-white" data-id="element-262" data-mp="3r0hhev3mzt7b">
                  Who is responsible for data collection on this website?
                </strong>
                <br data-id="element-263" data-mp="nld6l223u8h3" />
                Data processing on this website is carried out by the website
                operator. You can find their contact details in the section
                "Information on the Controller" in this privacy policy.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-264" data-mp="1267pg1s4bfp7">
                <strong className="text-white" data-id="element-265" data-mp="xa0ji8zq2479">
                  How do we collect your data?
                </strong>
                <br data-id="element-266" data-mp="sch3p4ndljd7" />
                Some data is collected because you provide it to us. This may,
                for example, be data you enter into a contact form.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-267" data-mp="jb0u2z4dxla1">
                Other data is collected automatically or with your consent by
                our IT systems when you visit the website. This is primarily
                technical data (e.g. internet browser, operating system or time
                of the page view). This data is collected automatically as soon
                as you enter this website.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-268" data-mp="3rprmfdss38ev">
                <strong className="text-white" data-id="element-269" data-mp="3rrm6kpw86whw">
                  What do we use your data for?
                </strong>
                <br data-id="element-270" data-mp="2c6jv23y95s37" />
                Some of the data is collected to ensure the website is provided
                without errors. Other data may be used to analyse how you use
                the site.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-271" data-mp="2l7rregh7kiun">
                <strong className="text-white" data-id="element-272" data-mp="2l4vvexox848u">
                  What rights do you have regarding your data?
                </strong>
                <br data-id="element-273" data-mp="1sht1kiv6whox" />
                You have the right to receive information about the origin,
                recipients and purpose of your stored personal data free of
                charge at any time. You also have the right to request the
                correction or deletion of this data. If you have given consent
                to data processing, you can withdraw that consent at any time
                with future effect. You also have the right to request the
                restriction of the processing of your personal data under
                certain circumstances. Furthermore, you have the right to lodge
                a complaint with the competent supervisory authority.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-274" data-mp="3l7vbbyqz8s7i">
                You can contact us at any time regarding this and any other
                questions on the subject of data protection.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-275" data-mp="3v3ev5ms9o0fw">
                Analytics Tools and Third-Party Tools
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-276" data-mp="811zuk7378ql">
                When you visit this website, your browsing behaviour may be
                analysed statistically. This is done primarily using so-called
                analytics programmes.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-277" data-mp="29tq4mxzdq48h">
                Detailed information about these analytics programmes can be
                found in the privacy policy below.
              </p>
            </section>

            <section className="mb-8" data-id="element-278" data-mp="1zohserkhaldc">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-279" data-mp="1zngkux2o8h0d">
                2. Hosting
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-280" data-mp="1luh2mnbi88p4">
                Webflow
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-281" data-mp="1bydqcomxutog">
                We host our website with Webflow. The provider is Webflow,
                Inc., 398 11th Street, 2nd Floor, San Francisco, CA 94103, USA
                (hereinafter "Webflow"). When you visit our website, Webflow
                records various log files including your IP addresses.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-282" data-mp="17ywn81uzi8mg">
                Webflow is a tool for building and hosting websites. Webflow
                stores cookies or other recognition technologies that are
                necessary to display the page, to provide certain website
                functions and to ensure security (necessary cookies).
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-283" data-mp="2vt053k68iizv">
                For details, please see Webflow's privacy policy:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-284" data-mp="2lwdl0xlqfvyw">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-285" data-mp="39rzrsma6snte">
                Webflow is used on the basis of Art. 6(1)(f) GDPR. We have a
                legitimate interest in presenting our website as reliably as
                possible. Where corresponding consent has been requested,
                processing takes place exclusively on the basis of Art. 6(1)(a)
                GDPR and Section 25(1) TTDSG, insofar as the consent covers the
                storage of cookies or access to information on the user's device
                (e.g. device fingerprinting) within the meaning of the TTDSG.
                Consent can be withdrawn at any time.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-286" data-mp="nkv7j5kruwbt">
                Data transfer to the USA is based on the standard contractual
                clauses of the EU Commission. You can find details here:{' '}
                <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-287" data-mp="wl9yakgi93mp">
                  https://webflow.com/legal/eu-privacy-policy
                </a>
                .
              </p>
            </section>

            <section className="mb-8" data-id="element-288" data-mp="20p2ig7rs9no6">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-289" data-mp="20o14nvjdun2r">
                3. General Information and Mandatory Disclosures
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-290" data-mp="2an8iskxxylqx">
                Data Protection
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-291" data-mp="25nvyo7ygfss1">
                The operators of these pages take the protection of your
                personal data very seriously. We treat your personal data
                confidentially and in accordance with the statutory data
                protection regulations and this privacy policy.
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-292" data-mp="1rq7aor93c5ir">
                When you use this website, various personal data is collected.
                Personal data is data that can be used to identify you
                personally. This privacy policy explains what data we collect
                and what we use it for. It also explains how and for what
                purpose this happens.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-293" data-mp="3anlv1xg89ecn">
                We point out that data transmission over the internet (e.g.
                when communicating by email) can have security gaps. Complete
                protection of data against access by third parties is not
                possible.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-294" data-mp="3oo4vojid5i4s">
                Information on the Controller
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-295" data-mp="3tjk7z70q35z3">
                The controller responsible for data processing on this website
                is:
              </p>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-296" data-mp="3kncpjz4sftcq">
                Justus Kraft LLC
                <br data-id="element-297" data-mp="24931z78de8my" />
                Represented by: Justus Kraft
                <br data-id="element-298" data-mp="296urxvpgfkoi" />
                7901 4th St. N, Ste. 300
                <br data-id="element-299" data-mp="fmfv8mzcz3sd" />
                St. Petersburg, FL 33702
                <br data-id="element-300" data-mp="foafdz2t2rve" />
                United States of America
                <br data-id="element-301" data-mp="jmpz9u3lbk4l" />
                Phone: +1 424-678-0686
                <br data-id="element-302" data-mp="5we39k3vx186" />
                Email: jk@kraftjustus.com
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-303" data-mp="5u9zd25zk27w">
                The controller is the natural or legal person who alone or
                jointly with others determines the purposes and means of
                processing personal data (e.g. names, email addresses, etc.).
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-304" data-mp="ux69zoitywv">
                Storage Period
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-305" data-mp="3o1hd1i4sq1ex">
                Unless a more specific storage period is stated within this
                privacy policy, your personal data will remain with us until the
                purpose for processing it no longer applies. If you assert a
                justified request for deletion or withdraw your consent to data
                processing, your data will be deleted unless we have other
                legally permissible reasons for storing your personal data (e.g.
                retention periods under tax or commercial law); in the latter
                case, deletion takes place once those reasons no longer apply.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-306" data-mp="2f4j4mqy68c1x">
                SSL / TLS Encryption
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-307" data-mp="2a56cbqoj6cry">
                For security reasons and to protect the transmission of
                confidential content, such as orders or enquiries you send to us
                as the site operator, this site uses SSL or TLS encryption. You
                can recognise an encrypted connection by the fact that the
                browser's address bar changes from "http://" to "https://" and
                by the lock symbol in your browser bar.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-308" data-mp="2owz0lfsw8ndq">
                When SSL or TLS encryption is activated, the data you transmit
                to us cannot be read by third parties.
              </p>
            </section>

            <section className="mb-8" data-id="element-309" data-mp="33rvcc2zwvsvk">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-310" data-mp="33swussj9bhnb">
                4. Data Collection on This Website
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-311" data-mp="3cstlezp7iql0">
                Cookies
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-312" data-mp="3hjteftv7goi8">
                Our web pages use so-called "cookies". Cookies are small text
                files and do not cause any damage to your device. They are
                stored on your device either temporarily for the duration of a
                session (session cookies) or permanently (persistent cookies).
                Session cookies are deleted automatically at the end of your
                visit. Persistent cookies remain stored on your device until you
                delete them yourself or until they are deleted automatically by
                your web browser.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-313" data-mp="1axdor9aj8kna">
                Contact Form
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-314" data-mp="23jyp2z8zk72z">
                If you send us enquiries via the contact form, the details you
                provide in the enquiry form, including the contact details you
                give there, will be stored by us for the purpose of processing
                the enquiry and in case of follow-up questions. We do not pass
                this data on without your consent.
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-315" data-mp="2mb805cyen3wo">
                Enquiries by Email, Phone or Fax
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-316" data-mp="2hhwql427k912">
                If you contact us by email, phone or fax, your enquiry,
                including all personal data resulting from it (name, enquiry),
                will be stored and processed by us for the purpose of handling
                your request. We do not pass this data on without your consent.
              </p>
            </section>

            <section className="mb-8" data-id="element-317" data-mp="2ks7vkyfpzax9">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-318" data-mp="2ktivgn61nyj3">
                5. Plugins and Tools
              </h2>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-319" data-mp="2pqhr5a5cwdje">
                YouTube
              </h3>
              <p className="text-[#94A3B8] leading-relaxed mb-4" data-id="element-320" data-mp="2b0k4iyn2rvwb">
                This website embeds videos from the YouTube website. The site is
                operated by Google Ireland Limited ("Google"), Gordon House,
                Barrow Street, Dublin 4, Ireland.
              </p>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-321" data-mp="38jv8udk26nh2">
                Further information on how user data is handled can be found in
                YouTube's privacy policy at:{' '}
                <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-322" data-mp="s1maikosfa9m">
                  https://policies.google.com/privacy
                </a>
                .
              </p>

              <h3 className="text-xl font-semibold mb-3 text-white mt-6" data-id="element-323" data-mp="965u88uv9yvm">
                Google Web Fonts
              </h3>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-324" data-mp="n2j3wvt5svzj">
                For the consistent display of typefaces, this site uses
                so-called web fonts provided by Google. When you call up a page,
                your browser loads the required web fonts into its browser cache
                in order to display texts and typefaces correctly.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}